import { InjectionToken } from '@angular/core';

export const ACCOUNT_ACCESS_REJECTED_URL = new InjectionToken<string>(
  'account-access-rejected-url'
);
